import {Injectable} from '@angular/core';
import {Mutation} from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root',
})
export class DeleteBarcodeListItemMutation extends Mutation {
  document = gql`
      mutation deleteBarcodeList($id: ID!) {
        deleteBarcodeList(where: {id: $id}) {
              id
          }
      }
  `;
}
